// Cookie consent management. Three categories:
//  - necessary  (always on)
//  - analytics  (track events, page_view)
//  - marketing  (UTM banner personalization persistence beyond session)

const KEY = "equisight_cookie_consent_v1";

export const DEFAULT_CONSENT = {
  necessary: true,
  analytics: false,
  marketing: false,
  decided: false,
  timestamp: null,
};

const safeWindow = () => (typeof window !== "undefined" ? window : null);

export const getConsent = () => {
  const w = safeWindow();
  if (!w) return DEFAULT_CONSENT;
  try {
    const raw = w.localStorage.getItem(KEY);
    if (!raw) return DEFAULT_CONSENT;
    return { ...DEFAULT_CONSENT, ...JSON.parse(raw) };
  } catch {
    return DEFAULT_CONSENT;
  }
};

export const setConsent = (partial) => {
  const w = safeWindow();
  if (!w) return;
  const next = {
    ...getConsent(),
    ...partial,
    decided: true,
    timestamp: new Date().toISOString(),
  };
  w.localStorage.setItem(KEY, JSON.stringify(next));
  // Notify subscribers
  w.dispatchEvent(new CustomEvent("equisight:consent", { detail: next }));
  return next;
};

export const acceptAll = () =>
  setConsent({ analytics: true, marketing: true });

export const rejectAll = () =>
  setConsent({ analytics: false, marketing: false });

export const subscribeConsent = (callback) => {
  const w = safeWindow();
  if (!w) return () => {};
  const handler = (e) => callback(e.detail);
  w.addEventListener("equisight:consent", handler);
  return () => w.removeEventListener("equisight:consent", handler);
};
